import React, {memo, useEffect, useState} from 'react';
import {View, TouchableOpacity, Text, Pressable, Animated, Easing, Platform} from 'react-native';

import { StyleSheet } from 'react-native';
import {colorPalette} from '../../../core/config/color.config';
import {RNEText} from '../../components';
import {Icon} from 'react-native-elements'; 


import useStores from '../../stores/useStores';

import {Photo} from '../../server/types/user.types';
import {
  ConsultationRequestResBody,
  ConsultationStatusEnum,
} from '../../server/types/consultation.types';
import {formatShortDate, formatToMessageTime, timestamp} from '../../utils/date.utils';

import {default as ConsultationPhoto} from './ConsultationPhoto';
import {isToday} from 'date-fns';
import {ProcedureStatusEnum} from '../../server/types/procedure.types';
import {ConsultationStatus} from '..';
import ConsultationListItemMenu from './ConsultationListItemMenu';
import { getFullName } from '../../utils/common.utils';
import { width, height, totalSize } from 'react-native-dimension';

interface ConsultationListItemPendingProps {
  item: ConsultationRequestResBody;
  onPress?: () => void;
}

const ConsultationListItemPending = (
  props: ConsultationListItemPendingProps,
) => {
  const {authStore} = useStores();
  const [showActions, setShowActions] = useState(false);

  const [displayName, setDisplayName] = useState('');
  const [displayPhoto, setDisplayPhoto] = useState<Photo>();
  const [displayStatus, setDisplayStatus] = useState(false);

  useEffect(() => {
    switch (authStore.userRole) {
      case 'patient':
        if (props.item.performer) {
          setDisplayName(
            `Dr. ${props.item.performer.humanName.given[0]} ${props.item.performer.humanName.family}`,
          );
          setDisplayPhoto(props.item.performer.photo);
        } else {
          setDisplayName('Deleted Profile');
        }
        break;

      case 'practitioner':
        if (props.item.subject) {
          if(getFullName(props.item.performer.humanName)){
            setDisplayName(getFullName(props.item.subject.humanName));
          }else{
            setDisplayName(
              `"Patient ${props.item.subject.patientId
                .substring(0, 6)
                .toUpperCase()}"`,
            );
          }
          
          setDisplayPhoto(props.item.subject.photo);
        } else {
          setDisplayName('Deleted Profile');
        }
        break;

      default:
        break;
    }

    if (props.item?.procedure) {
      if (
        props.item?.status === ConsultationStatusEnum.PENDING &&
        props.item?.procedure?.status === ProcedureStatusEnum.TO_PAY &&
        authStore.userRole === 'practitioner'
      ) {
        if (props.item.subject) {
          setDisplayName(
            `${props.item?.subject?.humanName.given[0]} ${props.item?.subject?.humanName.family}`,
          );
          setDisplayPhoto(props.item?.subject?.photo);
        } else {
          setDisplayName('Deleted Profile');
        }
        setDisplayStatus(true);
      }
    }
  }, [authStore.userRole, props]);

  const toggleActions = () => {
    setShowActions(!showActions);
  };
  

  return (
    <TouchableOpacity activeOpacity={0.75} onPress={props.onPress} style={{padding:totalSize(0), paddingTop:0,paddingBottom:0}}>
      <View style={styles.root}>

        <ConsultationListItemMenu
          item={props.item} 
          isMenuOpen={showActions}
          onCloseMenuPress={()=> setShowActions(!showActions)}
        />



        <View style={{flexDirection:'row', width:'100%'}}>
          <View style={{flexDirection:'row', width:'89%'}}>
            <View style={styles.photo}>
              <ConsultationPhoto photo={displayPhoto} />
            </View>

            <View style={styles.message}>
              <View>
                <RNEText
                  label={displayName}
                  // color="blackLight"
                  // weight="600"
                  numberOfLines={1}
                  ellipsizeMode="tail"
                  style={[
                    {fontFamily:'Quicksand-Bold', fontSize: totalSize(1.6)}
                  ]}
                />
              </View>

              <View style={{marginTop: Platform.OS === 'ios' ? height(0.5) : height(0.5)}}>
                <RNEText
                  // label={props.item.note[0].text}
                  label={
                    formatToMessageTime(
                        new Date(
                          props.item.note[0].time,
                        )
                      )
                  }
                  color="#81add0"
                  variant="button"
                  // weight="400"
                  numberOfLines={2}
                  ellipsizeMode="tail"
                  style={[
                    {fontFamily:'Quicksand-Regular'}
                  ]}
                />
              </View>

              {/* {
                displayStatus && ( */}
                  <View style={{marginTop: height(0.5)}}>
                      <ConsultationStatus
                        consultationStatus={props?.item?.status}
                        procedureStatus={props?.item?.procedure?.status}
                      />
                  </View>
              {/* //   )
              // } */}
              
            </View>
          </View>
          <View style={styles.timestamp}>
 
              {/* &&!props.item.procedure */}
            {
              authStore.userRole === 'patient'  && (
                <View style={{marginTop: Platform.OS === 'android' ? height(2) : height(1.5)}}>
                  <Pressable
                    onPress={toggleActions}
                  >
                    <Icon
                      name="dots-horizontal"
                      type="material-community"
                      color="#000"
                      size={totalSize(3.5)}
                    />
                  </Pressable>
                </View>
              )
            }

            {
              authStore.userRole === 'practitioner' && (
                <View style={{marginTop: Platform.OS === 'android' ? height(2) : height(1.5)}}>
                  <Pressable
                    onPress={toggleActions}
                  >
                    <Icon
                      name="dots-horizontal"
                      type="material-community"
                      color={colorPalette.black}
                      size={totalSize(3)}
                    />
                  </Pressable>
                </View>
              )
            }

            {/* {!displayStatus && ( */}
              {/* <RNEText
                label={
                  isToday(
                    new Date(props.item.note[props.item.note.length - 1].time),
                  )
                    ? timestamp(
                        new Date(
                          props.item.note[props.item.note.length - 1].time,
                        ),
                      )
                    : formatShortDate(
                        new Date(
                          props.item.note[props.item.note.length - 1].time,
                        ),
                      )
                }
                color="#81add0"
                variant="button"
                style={{textAlign:'right', fontFamily:'Quicksand-Regular', marginTop: height(1)}}
              /> */}
            {/* )} */}
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  actionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 0,
    marginLeft: 0, // to align under text (adjust based on avatar size)
    marginRight: 15,
    gap: 8,
  },
  actionButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 20,
  },
  decline: {
    borderColor: '#FFA500',
    borderWidth: 1,
  },
  accept: {
    backgroundColor: '#FFA500',
  },
  archive: {
    backgroundColor: '#3FB4E6',
  },
  actionText: {
    fontSize: 12,
    color: colorPalette.white,
    fontWeight: '600',
  },
  root: {
    flexDirection: 'row',
    // paddingHorizontal: width(6),
    paddingHorizontal: totalSize(1),
    paddingVertical: totalSize(2.5),
    // paddingVertical: height(1.2),
    borderBottomWidth: 1,   
    borderBottomColor: colorPalette.light,
  },
  photo: {},
  message: {
    // flex: 1,
    paddingHorizontal: totalSize(2),
    paddingTop: totalSize(0.2),
  },
  timestamp: {
    paddingTop: totalSize(0.1),
    alignContent:'center',
    alignItems:'center',
    width: width(11),
  },
});

export default memo(ConsultationListItemPending);
